import React from "react";
import { Box, ListItemIcon, ListItemText, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { StyledMenu, StyledMenuItem } from "../../../StyledMenu.jsx";
import { MoreVert } from "@mui/icons-material";
import * as api from "../../../../services/api.js";
import { errorsFromApi } from "../../../../form.jsx";
import { useSnackbarMessage } from "../../../Snackbar.jsx";
import { useTranslation } from "react-i18next";
import * as logging from "../../../../logging.js";

export function ExportMenu({ client_id }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const setSnackbarMessage = useSnackbarMessage();
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton
        id="export-menu-button"
        aria-controls={open ? "export-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreVert />
      </IconButton>

      <StyledMenu
        id="export-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        MenuListProps={{ "aria-labelledby": "export-menu-button" }}
      >
        <StyledMenuItem
          onClick={async () => {
            try {
              setAnchorEl(null);
              const result = await api.exportMedicalReport({
                client_id,
              });
              const errors = errorsFromApi({ t, result });
              if (errors.length === 0) {
                setSnackbarMessage({
                  content: "Zdravotní dokumentace poslána na export.",
                });
              } else {
                setSnackbarMessage({
                  content: "Nepovedlo se exportovat zdravotní dokumentaci.",
                  severity: "error",
                });
              }
            } catch (e) {
              logging.error(e);
              setSnackbarMessage({
                content: "Nepovedlo se exportovat zdravotní dokumentaci.",
                severity: "error",
              });
            }
          }}
        >
          <ListItemIcon>
            <FontAwesomeIcon icon={faFileExport} />
          </ListItemIcon>
          <ListItemText primary="Export lékařské zprávy" />
        </StyledMenuItem>
      </StyledMenu>
    </Box>
  );
}

export default ExportMenu;
